export const checkIfUnitHasPendingAdditionalSupply = (unitId, pendingSupply) => {
  return pendingSupply.find(s => s.unitId === unitId && s.additionalSupply)
}